<template>
  <div class="landing-container">
    <!-- Background layer: Logo ONLY -->
    <section class="landing-layer layer-bg">
      <div class="cover">
        <span class="cover-wrapper">
          <span class="left invisible">{{leftText}}</span>
          <img src="../assets/logo.png" alt="Cyclone RoboSub Main Logo" class="logo" decoding="async">
          <span class="right invisible">{{rightText}}</span>
        </span>
        <div class="robosub invisible">RoboSub</div>
      </div>
    </section>

    <!-- Foreground layer: Text ONLY -->
    <section class="landing-layer layer-fg">
      <div class="cover">
        <span class="cover-wrapper">
          <span class="left">{{leftText}}</span>
          <img src="../assets/logo.png" alt="Cyclone RoboSub Main Logo" class="logo invisible" decoding="async">
          <span class="right">{{rightText}}</span>
        </span>
        <div class="robosub">RoboSub</div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
    name: "LandingView",
    data(){
      return{
        leftText: "Cycl",
        rightText: "ne",
      }
    },
}
</script>

<style lang="scss" scoped>
@keyframes spin {
  from{transform: rotate(0deg);}
  to {transform: rotate(-360deg);}
}

@keyframes grow{
  from{max-width: 0;}
  to{max-width: 100%;}
}

@keyframes expand {
  from{max-height: 0;}
  to{max-height: 300px;}
}

.landing-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
}

.landing-layer {
    grid-area: 1 / 1;
    position: sticky;
    top: 0;
    left: 0;

    min-height: 100vh;
    // flex: 0 1 auto;

    // background: url("../assets/title card.png");
    background-size: 80%;
    background-repeat: no-repeat;
    background-position: center 25%;
    font-family: var(--font-accent);

    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;

    font-size: 15vw;
}

.layer-bg {
    z-index: -2;
}

.layer-fg {
    z-index: 0;
    pointer-events: none;
}

.invisible {
    visibility: hidden;
}

.landing-layer {
    .robosub{
      max-height: 0;
      font-size: 3vw;
      text-align: right;
      line-height: 1em;
      animation: expand 2s 1s forwards ease-in-out;
      overflow: hidden;
    }

    .cover{
      width: fit-content;

      .cover-wrapper{
        display: flex;
        flex-flow: row;
        justify-content: center;
        align-items: center;
        // font-size: 144pt;
        
        .logo {
          width: 1em;
          animation: spin 2s infinite linear;
        }
      }
    }

    .left, .right{
      max-width: 0;
      overflow: hidden;
      animation: grow 1s 500ms forwards ease-in-out;
    }
}

@media screen and (max-width: 768px) {
  .landing-layer{
    min-height: 0;
    height: 85vh;

    .robosub {
      font-size: clamp(0.95rem, 3.5vw, 1.4rem);
    }
  }
}


</style>